module.exports = __webpack_public_path__ + "img/frasle-old.cc45d463.jpg";